import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { style } from 'typestyle';
import { ServiceLocator } from '../../../../../app/ServiceLocator';
import { Messages } from '../../../../../codegen/Localize';
import { ClearSavedRevisionsAction } from '../../../../services/ClearSavedRevisionsAction';
import { RevisionHistorySectionProps } from './RevisionHistorySection';

const paddingTop = style({
  marginTop: TabStyles.Spacing.MediumSpace
});

export function RevisionHistoryClearButton(props: RevisionHistorySectionProps) {
  const handleClick = React.useCallback(() =>
      ServiceLocator.get<ClearSavedRevisionsAction>('ClearSavedRevisionsAction')
        .confirmDeleteSiteRevisions(undefined)
    , []);

  return (
    !props.hideRevisionHistoryLimitWarning
    && <ButtonWidget buttonType={ButtonType.Outline}
                     className={paddingTop}
                     onClick={handleClick}
                     testId={'clear-saved-revisions'}
                     type={'button'}>
      {Messages.clearSavedRevisions_action()}
    </ButtonWidget>
  );
}
